import {IconButton} from '@mui/material';
import styled from 'styled-components';
import theme from '../../theme/theme';

export const CardContainer = styled.div<{ $selected: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 12px;
    border-radius: 12px;
    background-color: #fff;
    border: 2px solid ${props => props.$selected ? theme.palette.primary.main : 'rgba(224, 224, 224, 1)'};
    cursor: pointer;
    transition: all 200ms ease;
    position: relative;
    min-width: 0;

    &:hover {
        border-color: ${props => props.$selected ? '#152033' : 'rgba(167, 178, 188, 1)'};
    }
`;

export const CardContent = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
`;

export const FileInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const FileName = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 4px;
`;

export const FileMetadata = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: rgba(107, 114, 128, 1);
`;

export const ExtensionBadge = styled.span`
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    background-color: rgba(29, 42, 65, 0.1);
    color: ${theme.palette.primary.main};
    font-weight: 600;
    text-transform: uppercase;
    font-size: 10px;
`;

export const DateText = styled.span`
    font-size: 11px;
`;

export const OptionsButton = styled(IconButton)`
    padding: 4px !important;
    opacity: 0;
    transition: opacity 0.2s;
    margin-left: auto;

    ${CardContainer}:hover & {
        opacity: 1;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 18px;
`;
